<template>
  <div class="terms">
    <transition name="auth-router" mode="out-in">
      <router-view class="router" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "terms",
  data() {
    return {
      path: "",
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.terms {
  display: inline-block;
  width: 100%;
}
</style>
